/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneConsent as ResolvedStandaloneConsent } from 'base/components/standalone/Consent';

export const Consent: typeof ResolvedStandaloneConsent = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneConsent {...props} />
        </ErrorBoundary>
    );
});

export type ConsentProps = PropsFromComponent<typeof Consent>;

/** @deprecated Use slot architecture instead */
export const ConsentWith = (extras: DynamicStandaloneExtras): typeof Consent => {
    return function Consent(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Consent');
        return <ResolvedStandaloneConsent {...mergeProps({ options: { theme } }, props)} />;
    }
}